/**
 * Service for consistent number formatting (scientific notation, decimals).
 */
export default class NumberFormatterService {
  /**
   * Format number in scientific notation
   */
  public formatScientific(value: number | null | undefined, decimals: number = 2): string {
    if (value === 0 || value === null || value === undefined) {
      return '0';
    }
    return value.toExponential(decimals);
  }

  /**
   * Format number with up to `decimals` decimal places, stripping trailing zeros.
   * E.g. 5000 → "5000", 12.5 → "12.5", 3.1416 → "3.1416"
   */
  public formatNumber(value: any, decimals: number = 4): string {
    const numValue = typeof value === 'object' && value !== null ? value.value : value;
    if (numValue === 0 || numValue === null || numValue === undefined) {
      return '0';
    }
    return String(parseFloat(Number(numValue).toFixed(decimals)));
  }

  /**
   * Format percentage
   */
  public formatPercentage(value: number | null | undefined, decimals: number = 2): string {
    if (value === null || value === undefined) {
      return '-';
    }
    return `${(value * 100).toFixed(decimals)}%`;
  }
}
